import { createActions, createReducer } from "reduxsauce";
import { BudgetsSaved } from "pages/Quotes/components/LastHits/interface";

export const { Types, Creators } = createActions({
  setAllBudgetsSaved: ['data']
});

const INITIAL_STATE: BudgetsSaved[] = [];

const setAllBudgetsSaved = (state = INITIAL_STATE, action: any) => ([ ...action.data ]);

export default createReducer(INITIAL_STATE, {
  [Types.SET_ALL_BUDGETS_SAVED as any]: setAllBudgetsSaved
});
